import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'

import "./Footer.css"
function Footer() {



  return (
    <>
      <footer className="three">
        <div class="section__container footer__container">
          <div class="footer__col">
            <h4>Navigation</h4>
            <ul class="footer__links">
              <NavLink to="/">
                <li>Home</li>
              </NavLink>
              <NavLink to="/contact">
                <li>Contact Us</li>
              </NavLink>
              
             
            </ul>
          </div>
          <div class="footer__col" id='left'>
            <h4>More</h4>
            <ul class="footer__links">
              <NavLink to="/about">
                <li>About Us</li>
              </NavLink>
              <NavLink to="/location">
                <li>Our Location</li>
              </NavLink>
              
            </ul>
          </div>
          <div class="footer__col" id='left'>
            <h4>More </h4>
            <ul class="footer__links">
             <NavLink to="/faq">
                <li>FAQ</li>
              </NavLink>
            </ul>
          </div>
          <div class="footer__col" >
            <h4>Follow Us</h4>
            <ul class="footer__socials">
              <li>
                <a href="https://www.instagram.com/morarahomefurniture/" target='_blank'><i class="ri-instagram-fill"></i></a>
              </li>
              <li>
                <a href="https://www.facebook.com/MoraraFurniture/" target='_blank'><i class="ri-facebook-fill"></i></a>
              </li>
              <li>
                <a href="https://www.tiktok.com/@morarahomefurniture" target='_blank'><i class="ri-tiktok-fill" id='ri-tiktok-fill'></i></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer__bar">
          Copyright © 2025 Morara Homes Furniture. All rights reserved.
          <br />
          A craft of <a href="https://iancodess.netlify.app/" target='_blank' className='iancodes'>ianCodes</a>



        </div>
      </footer>
    </>
  )
}

export default Footer
